<template>
  <div>
    <mu-card-header
      titleClass="largeTitle boldTitle"
      :title="title"
      :subTitle="subTitle">
      <mu-icon-button
        style="margin-right: 8px;"
        @click.native="goBack()"
        slot="avatar"
        icon="chevron_left"
      ></mu-icon-button>
    </mu-card-header>
    <mu-card-text>
      <form @submit.prevent="submitForm()" novalidate>
        <mu-row gutter>
          <mu-col width="100" desktop="80" tablet="100">
            <!-- Requires MedicationSearchMixin -->

            <div v-if="user.diabetes_type.is_diabetic">
              <div class="mu-text-field-label">{{$t('message.labelITakeThisForMy')}} {{user.diabetes_type.diabetes_type}}</div>
              <mu-radio :label="$t('message.labelYes')" name="group" :nativeValue="1" v-model="model.forDiabetes" class="demo-radio"/> <br/>
              <mu-radio :label="$t('message.labelNo')" name="group" :nativeValue="0" v-model="model.forDiabetes"  class="demo-radio"/> <br/>
            </div>

            <mu-auto-complete
              :scroller="scroller"
              :maxHeight="250"
              :inputClass="medicationInputClass"
              inputClass="mediSearchInput"
              @change="handleMedicationSelected"
              :openOnFocus="true"
              :dataSource="medicationDataSource"
              :dataSourceConfig="medicationDataSourceConfig"
              :fullWidth="true"
              v-model="medicationSearchValue"
              :maxSearchResults="10"
              hintText="Start typing for suggestions"
              filter="noFilter"
              fullWidth
              :label="$t('message.labelMedicationName')"
            />
            <!-- End required MedicationSearchMixin -->




            <mu-row v-if="model.forDiabetes === 0 && user.diabetes_type.is_diabetic || model.forDiabetes === 0 && user.diabetes_type.is_diabetic === false">
              <mu-select-field
                v-if="conditions.length > 0"
                v-validate="'required'"
                data-vv-value-path="inputValue"
                data-vv-name="condition"
                data-vv-validate-on="none"
                :errorText="errors.first('condition')"
                v-model="model.condition_id"
                :hintText="$t('message.searchText')"
                :label="$t('message.labelWhatDoYouTakeItFor')"
                fullWidth
              >
                <mu-menu-item
                  v-for="item in conditions"
                  :key="'condition-' + item.condition_id"
                  :title="item.condition_label"
                  :value="item.condition_id">
                </mu-menu-item>
              </mu-select-field>
            </mu-row>
            <mu-row gutter>
              <mu-col width="50" tablet="50" desktop="50">
                <mu-text-field

                  v-validate="'required'"
                  data-vv-value-path="inputValue"
                  data-vv-name="dosage"
                  data-vv-validate-on="none"
                  :errorText="errors.first('dosage')"
                  min="0"
                  type="number"
                  :label="$t('message.labelDosage')"
                  :hintText="$t('message.placeholderText')"
                  v-model.number="model.defaultDosage"
                  fullWidth
                >
                </mu-text-field>
              </mu-col>
              <mu-col width="50" tablet="50" desktop="50">
                <mu-select-field

                  v-validate="'required'"
                  data-vv-value-path="inputValue"
                  data-vv-name="units"
                  data-vv-validate-on="none"
                  :errorText="errors.first('units')"
                  :maxHeight="250"
                  v-model="model.unit_id"
                  :scroller="scroller"
                  :hintText="$t('message.selectText')"
                  :label="$t('message.labelUnits')"
                  fullWidth
                >
                  <mu-menu-item
                    v-for="(item, index) in regimes"
                    :value="item.ID"
                    :key="'regime-' + index"
                    :title="item.regimeUnitLabel"
                  ></mu-menu-item>
                </mu-select-field>
              </mu-col>
            </mu-row>
            <mu-select-field

              v-validate="'required'"
              data-vv-value-path="inputValue"
              data-vv-name="frequency"
              data-vv-validate-on="none"
              :errorText="errors.first('frequency')"
              :maxHeight="250"
              v-model="model.frequency_id"
              :scroller="scroller"
              :hintText="$t('message.selectText')"
              :label="$t('message.labelHowOften')"
              fullWidth
            >
              <mu-menu-item
                v-for="(item, index) in frequencies"
                :value="item.ID"
                :key="'frequency-' + index"
                :title="item.frequency"
              ></mu-menu-item>
            </mu-select-field>
          </mu-col>
        </mu-row>


        <button type="submit" style="display:none"></button>

        <mu-raised-button
          class="large"
          @click.native="submitForm()"
          :disabled="isSaving"
          type="button"
          fullWidth
          :label="!isSaving ? $t('message.saveText'): $t('message.savingText')"
          secondary>
        </mu-raised-button>
      </form>
      <div style="margin-top: 16px" class="isError" v-if="isError" v-text="errorMessage"></div>
    </mu-card-text>
  </div>
</template>
<script>


  import MedicationSearchMixin from '../../../mixins/MedicationSearchMixin'
  import ScrollerMixin from '../../../mixins/ScrollerMixin'

  import UserApi from '../../../api/User'
  import MedicationApi from '../../../api/Tracking/Medication'

  export default {
    mixins: [
      MedicationSearchMixin,
      ScrollerMixin
    ],
    data() {
      return {
        title: this.$t('message.medicationPreferencesAdd'),
        subTitle: this.$t('message.medicationPreferencesAddSubTitle'),
        isSaving: false,
        isError: false,
        errorMessage: "",
        model: {
          frequency_id: null,
          frequency_label: null,
          treatment_id: null,
          treatment_name: null,
          unit_id: null,
          unit_label: null,
          condition_id: "",
          condition_label: "",
          defaultDosage: 1,
          forDiabetes: 0
        },
        regimes: [],
        frequencies: [],
        conditions: []
      }
    },
    watch: {
      'model.frequency_id': function () {
        let self = this;
        if (self.model.frequency_id) {
          self.model.frequency_label = self.frequencies.filter(function (frequency) {
            return frequency.ID === self.model.frequency_id
          })[0].frequency
        }
      },
      'model.unit_id': function () {
        let self = this;
        if (self.model.unit_id) {
          self.model.unit_label = self.regimes.filter(function (unit) {
            return unit.ID === self.model.unit_id
          })[0].regimeUnitLabel
        }
      },
      'model.condition_id': function () {
        let self = this;
        if (self.model.condition_id) {
          self.model.condition_label = self.conditions.filter(function (condition) {
            return condition.condition_id === self.model.condition_id
          })[0].condition_label
        }
      }
    },
    mounted() {
      let self = this;
      UserApi.getUserConditions()
        .then(function (response) {
          self.conditions = response.data;
        });

      MedicationApi.regimeUnitsGet()
        .then(function (response) {
          self.regimes = response.data;
        });

      MedicationApi.regimeFrequencysGet()
        .then(function (response) {
          self.frequencies = response.data;
        });
    },
    methods: {
      submitForm() {
        let self = this;
        if (!self.model.treatment_name) {
          self.$toastr.error("Please enter a medication name");
          return;
        }
        self.$validator.validateAll().then(function (valid) {
          if (valid) {
            self.isSaving = true;
            MedicationApi.postUserMedication(self.model)
              .then(function () {
                self.isSaving = false;
                self.$router.push({name: 'SettingsMedication'})
              })
              .catch(function (error) {
                self.errorMessage = self.$t('message.medicationAlreadyTrackingError');
                self.isError = true;
                self.isSaving = false;
                setTimeout(function () {
                  self.isError = false;
                  self.isSaving = false;
                }.bind(self), 2000)
              })
          }
          else {
            //error
          }
        })
      },
      goBack() {
        let self = this;
        self.$router.push({
          name: 'SettingsMedication'
        })
      },
      handleMedicationSelected(value) {
        let self = this;
        if (value.length > 0) {
          if (self.medicationDataSource.length > 0) {
            let medication = self.medicationDataSource.filter(function (medication) {
              return medication.treatment_name === value
            })[0];
            self.$nextTick(function () {
              self.model.treatment_name = medication.treatment_name;
              self.model.treatment_id = medication.treatment_id;
            });
          }
        }
        else {
          self.medicationDataSource = [];
          self.model.treatment_id = null;
          self.model.treatment_name = null;
        }
      }
    },
    computed: {
      user() {
        let self = this;
        return self.$store.state.user.scope;
      }
    }
  }
</script>
<style scoped>
  .mu-text-field-label {
    color: #0179d5;
    text-transform: uppercase;
    font-weight: 500;
    font-size: initial;
  }
</style>



// WEBPACK FOOTER //
// Add.vue?15b8e2a4